import { LazyFeature } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy } from 'react';
var ConfirmationDialogLazy = lazy(function () {
    return import(
    /*webpackChunkName: "confirmation-dialog-component" */ '@office-start/confirmation-dialog-component');
});
export var ConfirmationDialog = function () {
    return (React.createElement(LazyFeature, { schedulePriority: IDLE_VERYLOW_PRIORITY },
        React.createElement(ConfirmationDialogLazy, null)));
};
//# sourceMappingURL=ConfirmationDialog.js.map